export default 'M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24m9-12c0 4.96-4.04 9-9 9V3c4.96 0 9 4.04 9 9';